import type { AssetTypeTemplateDuplicateFormProps } from "./asset-type-template-duplicate-form.type";

import { ModelDuplicateForm } from "@/modules/model-duplicate";

import { useAssetTypeTemplateDuplicateForm } from "./asset-type-template-duplicate-form.hook";

const AssetTypeTemplateDuplicateForm = (
  props: AssetTypeTemplateDuplicateFormProps
) => {
  const {
    form,
    formId,
    initialValues,
    onFormSubmit,
    isPending,
    validation,
    validationErrors,
  } = useAssetTypeTemplateDuplicateForm(props);

  return (
    <ModelDuplicateForm
      form={form}
      formId={formId}
      initialValues={initialValues}
      onFormSubmit={onFormSubmit}
      loading={isPending}
      validation={validation}
      validationErrors={validationErrors}
    />
  );
};

export default AssetTypeTemplateDuplicateForm;
